import { setClearReducer, setReducer } from "../../../reducer/creators"
import { EventDefinition } from "../EventDefinition"
import { EventDetails } from "../EventDetails"
import { CLEAR_EVENT_DETAILS, SET_EVENTS, SET_EVENT_DETAILS } from "../actions"

export const events = setReducer<{ hasNextPage: boolean; events: EventDefinition[] }>([SET_EVENTS], { hasNextPage: true, events: [] })
export const eventDetails = setClearReducer<EventDetails>([SET_EVENT_DETAILS], [CLEAR_EVENT_DETAILS])
